export default __webpack_public_path__ + "static/media/attendance-summery.801fce35.png";